// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1lrAv","top":"styles_top__1VJ15"};